<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sDsHa1/tc-custom/9781467445412.jpg?1731883574984" alt="This image is the cover for the book Discovering Genesis, Discovering Biblical Texts (DBT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Discovering Genesis, Discovering Biblical Texts (DBT)
      </h1>
      <p class="bookDescription body article font2">
        <i>Concise, student-friendly introduction to Genesis</i><br/>  <br/> Iain Provan here offers readers a compact, up-to-date, and student-friendly introduction to the book of Genesis, focusing on its structure, content, theological concerns, key interpretive debates, and historical reception.<br/>  <br/> Drawing on a range of methodological approaches (author-, text-, and reader-centered) as complementary rather than mutually exclusive ways of understanding, <i>Discovering Genesis</i> encourages students to dig deeply into the theological and historical questions raised by the text. It provides a critical assessment of key interpreters and interpretive debates, focusing especially on the reception history of the biblical text, a subject of growing interest to students and scholars of the Bible.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Iain Provan
      </h2>
      
      <p class="authorDescription body article">Iain Provan is Marshall Sheppard Professor of Biblical Studies at Regent College. His other books include <I>A Biblical History of</I><I>Israel</I>, The NIV Application Commentary volume on Ecclesiastes and Song of Songs, and <I>Seriously Dangerous Religion: What the Old</I><I>Testament Really Says and Why It Matters.</I><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Society for Promoting Christian Knowledge
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?809887c0